import {
    Box,
    Button,
    Collapse, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography
} from "@mui/material";
import {themeColors} from "../styles/theme";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {Dispatch, SetStateAction} from "react";
import {PrimaryButton} from "./Home";

interface FlatMeshDialogProps {
    flatMeshModalOpen: boolean;
    setFlatMeshModalOpen: (open: boolean) => void;
    flatMeshErrorMessage: string;
    flatMeshDebugInfo?: string;
    showDebugInfo: boolean;
    setShowDebugInfo: Dispatch<SetStateAction<boolean>>;
}

export const FlatMeshDialog = ({
    flatMeshModalOpen,
    setFlatMeshModalOpen,
    flatMeshErrorMessage,
    flatMeshDebugInfo,
    showDebugInfo,
    setShowDebugInfo,
}: FlatMeshDialogProps) => {
    return <Dialog
        open={flatMeshModalOpen}
        onClose={() => {
            setFlatMeshModalOpen(false);
            setShowDebugInfo(false); // Reset debug view when closing modal
        }}
        PaperProps={{
            sx: {
                borderRadius: 3,
                maxWidth: 500,
                backgroundColor: themeColors.paperYellow,
                px: 1
            }
        }}
    >
        <DialogTitle
            sx={{
                fontWeight: 600,
                color: 'black',
                pt: 3,
                pb: 1,
                font: "'DM Sans', sans-serif",
            }}
        >
            LOCATION NOT SUPPORTED
        </DialogTitle>

        <DialogContent sx={{ padding: '16px 24px' }}>
            <DialogContentText
                sx={{ color: themeColors.darkBackground, mb: 2 }}
            >
                {flatMeshErrorMessage}
            </DialogContentText>

            {flatMeshDebugInfo && (
                <>
                    <Button
                        onClick={() => setShowDebugInfo(!showDebugInfo)}
                        startIcon={showDebugInfo ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        sx={{
                            textTransform: 'none',
                            color: '#666',
                            fontSize: '0.85rem',
                            mb: 1,
                            p: 0,
                            '&:hover': {
                                backgroundColor: 'transparent',
                                textDecoration: 'underline',
                            }
                        }}
                    >
                        {showDebugInfo ? 'Hide technical details' : 'Show technical details'}
                    </Button>

                    <Collapse in={showDebugInfo}>
                        <Box sx={{
                            p: 2,
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            borderRadius: 1,
                            borderLeft: '3px solid #999',
                            mt: 1,
                            mb: 2,
                            overflowX: 'auto'
                        }}>
                            <Typography variant="caption" sx={{
                                fontFamily: 'monospace',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                color: '#666'
                            }}>
                                {flatMeshDebugInfo}
                            </Typography>
                        </Box>
                    </Collapse>
                </>
            )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
            <PrimaryButton
                onClick={() => {
                    setFlatMeshModalOpen(false);
                    setShowDebugInfo(false); // Reset debug view when closing modal
                }}
                sx={{
                    backgroundColor: 'transparent',
                    color: 'black',
                    fontWeight: 500,
                    px: 3,
                    borderRadius: 2,
                    '&:hover': {
                        backgroundColor: themeColors.mainYellow,
                    }
                }}
            >
                OKAY
            </PrimaryButton>
        </DialogActions>
    </Dialog>
}